
// Toggle blog filter list in mobile view
document.querySelectorAll(".cdk-mobile-button").forEach(function(button) {
  button.addEventListener("click", function() {
    const blogFilterList = document.querySelector(".blog-filter-list-mobile");
    if (blogFilterList.style.display === "none" || !blogFilterList.style.display) {
      blogFilterList.style.display = "block";
    } else {
      blogFilterList.style.display = "none";
    }
  });
});

// Toggle custom article items in mobile view
document.querySelectorAll(".Custom_article-mobile-btn").forEach(function(button) {
  button.addEventListener("click", function() {
    const customArticleItem = document.querySelector(".custom-article-item");
    if (customArticleItem.style.display === "none" || !customArticleItem.style.display) {
      customArticleItem.style.display = "block";
    } else {
      customArticleItem.style.display = "none";
    }
  });
});

// Handle guide click events
document.querySelectorAll(".custom-article-guide .guide").forEach(function(guide) {
  guide.addEventListener("click", function(event) {
    event.preventDefault();
    var deviceWidth = window.innerWidth;
    var scrolldiv = guide.getAttribute("tab-scroll");

    if (deviceWidth <= 991) {
      document.querySelectorAll('.custom-article-guide .guide').forEach(function(item) {
        item.classList.remove("active");
      });
      guide.classList.add("active");
    }

    setTimeout(function() {
      var targetElement = document.querySelector(".image_with_text[tab-to-scroll='" + scrolldiv + "']");
      if (targetElement) {
        window.scrollTo({
          top: targetElement.offsetTop - 200,
          behavior: "smooth"
        });
      }
    }, 200);
  });
});

// Scroll event to update the active class
window.addEventListener("scroll", function() {
  var deviceWidth = window.innerWidth;
  if (deviceWidth >= 992) {
    var scrollPos = document.documentElement.scrollTop || document.body.scrollTop;
    document.querySelectorAll('.image_with_text').forEach(function(refElement) {
      var currLink = document.querySelector(".custom-article-guide .guide[tab-scroll='" + refElement.getAttribute("tab-to-scroll") + "']");
      if (currLink && refElement.offsetTop - 200 <= scrollPos && refElement.offsetTop + refElement.offsetHeight > scrollPos) {
        document.querySelectorAll('.custom-article-guide .guide').forEach(function(link) {
          link.classList.remove("active");
        });
        currLink.classList.add("active");
      }
    });
  }
});

class RebuyRecommendations extends HTMLElement {
  constructor() {
    super();
    this.getProducts();
  }

  getProducts() {
    const requestParameters = new URLSearchParams({
      shopify_product_ids: this.dataset.ids,
      limit: this.dataset.limit,
      key: '80452357e2c285be3ee258f9583558ba47251340',
    });

    fetch(this.dataset.url + requestParameters)
      .then((response) => response.json())
      .then((data) => {
        let promiseArray = [];

        for (const product of data.data) {
          promiseArray.push(
            fetch(`/products/${product.handle}?view=card-recommendation`).then((resp) => resp.text())
          );
        }

        Promise.all(promiseArray).then((values) => {
          let code = '';

          // render products to container
          for (const [index, value] of Object.entries(values)) {
            code += `${value}`;
          }

          this.innerHTML = code;
          this.closest('scroll-carousel').setItems();
          this.closest('scroll-carousel').connectedCallback();

          window._conv_q = window._conv_q || [];

          if (document.body.classList.contains('template-cart')) {
            let target1 = document.querySelector('.template-cart .shopify-section--featured-collection scroll-carousel');
            if (target1) {
              target1.addEventListener('click', e => {
                _conv_q.push(["triggerConversion", "100472301"]);
              });
            }

            let target2 = document.querySelector('.template-cart .shopify-section--featured-collection scroll-carousel button[type="submit"]');
            if (target2) {
              target2.addEventListener('click', e => {
                _conv_q.push(["triggerConversion", "100472305"]);
              });
            }
          }
        });
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define('rebuy-recommendations', RebuyRecommendations);